import React, { FC, useCallback, useEffect } from 'react'
import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import clsx from 'clsx'
import { useHistory, useLocation } from 'react-router-dom'
import { BankAccounts } from './BankAccounts'
import { Wallets } from './Wallets'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    backGroundColor: 'transparent',
    '& .MuiBox-root': {
      padding: 0,
    },
    '& .Mui-selected': {
      opacity: 1,
      color: theme.palette.secondary.main,
    },
  },
  tabPanel: {
    width: '100%',
    backgroundColor: 'transparent',
    '& > div': {
      width: '100%',
    },
  },
  buttonsWrap: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),

    '&div': {
      width: 300,
    },

    '& button': {
      backgroundColor: 'transparent',
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
      textTransform: 'none',
      width: 150,
      height: 40,
      // borderRadius: 8,
    },

    '& .Mui-selected': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.main,
        background: theme.palette.secondary.light,
      },
      '&.MuiButton-contained.Mui-disabled': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.main,
        opacity: 0.6,
      },
    },
  },
}))

enum AccountsPanel {
  wallets = 'wallets',
  bankAccounts = 'bank-accounts',
}

interface Props {
  classes?: {
    root?: string
    tabs?: string
    tabPanel?: string
  }
}

export const ToggleButtons: FC<Props> = (props) => {
  const [activePanel, setActivePanel] = React.useState<AccountsPanel>(AccountsPanel.wallets)
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  const currentPanel = React.useMemo(() => {
    const { pathname } = location
    if (pathname.includes('/accounts/bank-accounts')) {
      return AccountsPanel.bankAccounts
    }
    if (pathname.includes('/accounts/wallets')) {
      return AccountsPanel.wallets
    }
    return AccountsPanel.wallets
  }, [location])

  const handleChange = useCallback(
    (e, newPanel) => {
      if (newPanel !== null) {
        setActivePanel(newPanel)
        history.push(`/finance/accounts/${newPanel}?page=1`)
      }
    },
    [history],
  )

  useEffect(() => {
    if (!location.pathname.includes('/accounts/wallets') && !location.pathname.includes('/accounts/bank-accounts')) {
      history.push(`/finance/accounts/${AccountsPanel.wallets}?page=1`)
    }
  }, [history, location.pathname])

  useEffect(() => {
    setActivePanel(currentPanel)
  }, [currentPanel])

  return (
    <div className={clsx(classes.root, props.classes?.root)}>
      <Grid container>
        <ToggleButtonGroup value={activePanel} exclusive onChange={handleChange} className={classes.buttonsWrap}>
          <ToggleButton value={AccountsPanel.wallets}>Wallets</ToggleButton>
          <ToggleButton value={AccountsPanel.bankAccounts}>Bank Accounts</ToggleButton>
        </ToggleButtonGroup>
      </Grid>

      <Grid container className={clsx(classes.tabPanel, props.classes?.tabPanel)}>
        {activePanel === AccountsPanel.wallets && <Wallets />}
        {activePanel === AccountsPanel.bankAccounts && <BankAccounts />}
      </Grid>
    </div>
  )
}
